<!--
    La paginas para administrar Personas
-->
<div class="page" id="user-collection-page">
  <div class="action-bar dark-bg with-tabs">
    <div class="title">Personas</div>
    <div class="tabs">
      <a class="tab" href="#personas?estado=A">Activas</a>
      <a class="tab" href="#personas?estado=I">Inactivas</a>
      <a class="tab" href="#personas?estado=X">Eliminadas</a>
      <a class="tab" href="#personas?estado=*">Todas</a>
    </div>
    <div class="actions-set">
      <a class="action-btn back" href="#home"></a>
      <a class="action-btn search" href="#"></a>
      <a class="action-btn add" href="#persona?id=nuevo">Agregar una nueva persona</a>
      <a class="action-btn sos" href="#">SOS</a>
    </div>
  </div>
  <div class="content">
    <div class="container">
      <div class="section" id="personas">
        <div class="list-content"></div>
      </div>
    </div>
  </div>
</div>

<div class="page legacy-page overlayed" id="user-page">
  <div class="action-bar dark-bg">
    <div class="title no-margin">Persona:</div>
    <div class="actions-set">
      <a class="action-btn done SaveBtn" href="#"></a>
      <a class="action-btn cancel CancelBtn" href="#personas?estado=A"></a>
      |
      <a class="action-btn delete" href="#"></a>
      <a class="action-btn sos" href="#">SOS</a>
    </div>
  </div>
  <div class="page-overlay"></div>
  <div class="content with-sidebar">
    <div class="legacy-sidebar">
      <div class="pane cache">
        <h4>Otros usuarios</h4>
        <a class="user-link" href="#">Juan Jorge Perez de Cuellar</a>
      </div>
    </div>
    <div class="container legacy-container">
      <div class="section" id="persona">
        <form class="legacy-form">
          <a class="action-btn CancelBtn" icon="cancel" href="#personas?estado=A"></a>
          <h2>
            Informacion del usuario
          </h2>
          <br />
          <ul>
            <li class="StringCtrl required" property="names">
              <label>Nombre(s) <b>*</b></label>
              <input name="name" type="text" size="35" placeholder="" />
              <p class="hint">Ingrese su nombre, o nombres. Este campo es necesario.</p>
            </li>
            <li class="StringCtrl required" property="surnames">
              <label>Apellido(s) <b>*</b></label>
              <input type="text" size=32 placeholder="" />
              <p class="hint">Ingresa aquí el apellido (o apellidos) de esta Persona. Este campo es necesario.
                A continuación puedes agregar otra información útil que la describe.</p>
            </li>
            <li class="StringCtrl required" property="email">
              <label>Email <b>*</b></label>
              <input type="text" size="35" />
              <p class="hint">Ingrese su correo electrónico. Este campo es
                necesario y muy importante, ya que lo usará para iniciar su sesión.</p>
            </li>
            <li class="StringCtrl required" property="password">
              <label>Contraseña <b>*</b></label>
              <input type="text" size="35" />
              <p class="hint">Ingrese una contraseña. Este campo es
                necesario y muy importante, ya que lo usará para iniciar su sesión.</p>
            </li>

            <li class="MultiSelectCtrl" property="roles">
              <label>Roles </label>
              <p class="options">&nbsp;</p>
              <select></select>
              <p class="hint">Seleccione uno o más de los roles asignados a esta persona.</p>
            </li>

            <li class="SelectCtrl" property="state">
              <label>Estado</label>
              <select name="state">
                <option value="A">Activo</option>
                <option value="I">Inactivo</option>
                <option value="X">Eliminado</option>
              </select>
            </li>

            <li class="StringCtrl" property="poe">
              <label>Punto<br />de emisión</label>
              <input type="text" size="35" class="big" />
              <p class="hint">Codigo asociado al usuario usado al momento de emisión
                de un ticket (Punto de Emisión o Punto de Venta, segun sea el caso).
                Se usa en conjunto con los Contadores.</p>
            </li>

            <li class="JsonCtrl" property="counters">
              <label>Contadores</label>
              <div>
                <a class="aside" ref="#que-son-los-contadores">Qué son los Contadores ?</a>
                &nbsp;
                <button class="small add AddOptionBtn"> &nbsp; Agregar un contador</button>
                <p class="aside-content hidden" id="que-son-los-contadores">
                  Contadores asociados a este usuario para la emisión de tickets y recibos
                  con numeración única y secuencial. Se usan en conjunto con el Punto de emisión.
                  <u class="br">&nbsp;</u>
                  <b>Para cada contador</b> se deben definir los "prefijos" que se usaran
                  para generar el número de cada ticket, y el valor inicial que se asignara
                  al mismo.
                  <u class="br">&nbsp;</u>
                  <b>Por ejemplo</b>: si el prefijo es "RC", y el punto de emisión es "00023" se
                  generarán los tickets "RC-00023-1", "RC-00023-2", "RC-00023-3" y así sucesivamente.
                </p>
              </div>
              <br />
              <p class="lines"></p>
              <textarea name="counters" cols="46" rows="1" class="hidden"></textarea>
            </li>

            <li class="JsonCtrl" property="extras">
              <label>EXtras (debe estar oculto)</label>
              <textarea name="extras" cols="46" rows="2" class="hidden"></textarea>
            </li>

          </ul>
          <p class="form-buttons">
            <button class="accept CreateBtn">AGREGAR ESTA PERSONA</button>
            <button class="accept SaveBtn">GUARDAR LOS CAMBIOS</button>
          </p>
      </div>
    </div>
  </div>
</div>

<script>

import { onMount } from 'svelte'
onMount(() => {
  window.$("#user-page").UserPage("#persona");
  window.$("#user-collection-page").UsersCollectionPage("#personas");
})
</script>